import { NgModule } from "@angular/core"
import { AdBanner } from "./ad-banner.component"
import { CommonModule } from "@angular/common"

@NgModule({
  imports: [CommonModule],
  declarations: [AdBanner],
  exports: [AdBanner]
})
export class AdBannerModule {}
